import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalService } from '../../shared/services/global.service';
import { map } from 'rxjs/operator/map';
import { MasterMappingModel } from './../master-mappings.model';
import { ToastrMessageType } from '../../shared/enums/toastr-message-type.enum';

@Component({
  selector: 'app-master-mappings-edit',
  templateUrl: './master-mappings-edit.component.html',
  styleUrls: ['./master-mappings-edit.component.scss']
})
export class MasterMappingsEditComponent implements OnInit {

  private form: FormGroup;

  constructor(
      private globalService: GlobalService,
      private router: Router,
      private route: ActivatedRoute,
      private formBuilder: FormBuilder) {

        let masterMappingId = 0;
        this.route.params
          .subscribe(params => {
            if (params['id']) {
              masterMappingId = +params['id'];
              this.getMappings(masterMappingId);
            }
          });

        this.form = formBuilder.group({
          MasterMappingId: 0,
          MasterMappingName: ['', Validators.required],
          Labels: this.formBuilder.array([
            this.initLabel(masterMappingId),
            this.initLabel(masterMappingId),
            this.initLabel(masterMappingId),
            this.initLabel(masterMappingId),
            this.initLabel(masterMappingId)
          ])
        });
  }

  initLabel(masterMappingId: number) {
    return this.formBuilder.group({
      LabelId: 0,
      MasterMappingId: masterMappingId,
      Label: ''
    });
  }

  ngOnInit() {
  }

  mapToForm(mapping: MasterMappingModel) {
    if (!mapping)
      return;

    this.form.patchValue(mapping);
    // (<FormArray>this.form.controls['Labels']).at(4).patchValue({
    //   MasterMappingId: 24
    // });
  }

  getMappings(mappingId: number) {
    this.globalService.httpGet(`/MasterMappings/${mappingId}`)
      .subscribe(response => {
        this.mapToForm(response as MasterMappingModel);
      });
  }

  saveMapping() {
    this.globalService.httpPost('/MasterMappings', this.form.value)
      .subscribe(response => {
        // this.form.patchValue(response as MasterMappingModel);
        this.globalService.showMessage('Mapping Saved.', ToastrMessageType.Success);
        this.router.navigate(['masterMappings/maintenance']);
      }, error => this.globalService.handleErrorObservable(error, 'An error occurred while saving Mapping'));
  }

  get diagnostic() {
    return JSON.stringify(this.form.value);
  }
}
